module.exports = __webpack_public_path__ + "img/bar-chart-10.e1197806.svg";